import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import documentRequirementService from '../../services/document-requirement';

const initialState = {
  loading: false,
  documentRequirements: [],
  error: '',
  meta: {},
};

export const fetchDocumentRequirements = createAsyncThunk(
  'document-requirement/fetchDocumentRequirements',
  (params = {}) => {
    return documentRequirementService.getAll(params).then((res) => res.data);
  },
);

const documentRequirementSlice = createSlice({
  name: 'documentRequirement',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchDocumentRequirements.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchDocumentRequirements.fulfilled, (state, action) => {
      //   console.log('Original API response:', action.payload);

      // Check if the response has the expected structure - simplified condition
      if (action.payload && action.payload.data) {
        const responseData = action.payload;
        console.log('Response data structure:', responseData);

        // The data array is directly in responseData.data
        if (Array.isArray(responseData.data)) {
          console.log('Document items found:', responseData.data.length);

          // Map the API field names to what our components expect
          state.documentRequirements = responseData.data.map((item) => ({
            id: item.id,
            title: item.name,
            form_type: item.form_key,
            is_required: item.is_required,
            allowed_types: item.allowed_types,
            created_at: item.created_at,
            updated_at: item.updated_at,
          }));

          console.log(
            'Mapped document requirements:',
            state.documentRequirements,
          );

          // Map pagination info directly from responseData
          state.meta = {
            current_page: responseData.current_page,
            per_page: responseData.per_page,
            total: responseData.total,
          };
        } else {
          // Handle case where data is not an array
          state.documentRequirements = [];
          state.meta = {
            current_page: 1,
            per_page: 10,
            total: 0,
          };
          console.error('Expected data to be an array:', responseData.data);
        }
      } else {
        // Handle unexpected response structure
        state.documentRequirements = [];
        state.meta = {
          current_page: 1,
          per_page: 10,
          total: 0,
        };
        console.error('Unexpected response structure:', action.payload);
      }

      console.log(
        'Final state documentRequirements:',
        state.documentRequirements,
      );
      console.log('Final state meta:', state.meta);

      state.loading = false;
      state.error = '';
    });
    builder.addCase(fetchDocumentRequirements.rejected, (state, action) => {
      state.loading = false;
      state.documentRequirements = [];
      state.error = action.error.message;
    });
  },
});

export default documentRequirementSlice.reducer;
